export const checksums = {
  "locales": "v3.5.0--ALf6FVeKIK8xM2kuiZQyYAThNigpzq4pB475U32iTLA",
  "recipes": "v3.5.0--nIEQp40T-BsrlTll8_gi0JZJZ8_ujFO9xypi9e4f7A8",
  "docs": "v3.5.0--jfSFz3ZuunN0AtTBqtXDIR_mzExXh3wp5JrkWGnzR68",
  "voixuserguide": "v3.5.0--0TAs5Ou0yFoZOZ6RdqVl1ngCMVt-dX8G-UBPjwtz0iA"
}
export const checksumsStructure = {
  "locales": "MUD7PhNehZwnHfv4lK6CYcX_mXIUci-hAlafExf135k",
  "recipes": "VjS2WINwFdN-H11kp7H1EIX5ggk3PHzSIfxmNz6JnFY",
  "docs": "RQ8AoU9-lZjh12QOotexakTI8fjr8W5wIq4rljMcmFw",
  "voixuserguide": "MPDD2LdZ0t_gRfxqnhFXPSwk1GSPXM4MIpARl0W-xfc"
}

export const tables = {
  "locales": "_content_locales",
  "recipes": "_content_recipes",
  "docs": "_content_docs",
  "voixuserguide": "_content_voixuserguide",
  "info": "_content_info"
}

export default {
  "locales": {
    "type": "data",
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json"
    }
  },
  "recipes": {
    "type": "page",
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json",
      "path": "string",
      "title": "string",
      "description": "string",
      "seo": "json",
      "body": "json",
      "navigation": "json",
      "name": "string",
      "layout": "string",
      "recipe": "json"
    }
  },
  "docs": {
    "type": "page",
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json",
      "path": "string",
      "title": "string",
      "description": "string",
      "seo": "json",
      "body": "json",
      "navigation": "json",
      "view": "string",
      "order": "number"
    }
  },
  "voixuserguide": {
    "type": "page",
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json",
      "path": "string",
      "title": "string",
      "description": "string",
      "seo": "json",
      "body": "json",
      "navigation": "json",
      "view": "string",
      "order": "number"
    }
  },
  "info": {
    "type": "data",
    "fields": {}
  }
}